import React from 'react';

import { useIntl } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { connect } from 'react-redux';

import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import HowItWorksSection from '../LandingPage/CustomSections/HowItWorksSection';

const HowItWorksPageComponent = props => {
  const { scrollingDisabled } = props;
  const intl = useIntl();

  return (
    <Page
      title={intl.formatMessage({ id: 'HowItWorksPage.title', defaultMessage: 'How It Works' })}
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <HowItWorksSection />
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const HowItWorksPage = connect(mapStateToProps)(HowItWorksPageComponent);

export default HowItWorksPage;
